import { ApprovalStatusTag } from 'ui-product-approvals/components';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { ApprovalValueToStatus } from '../../constants/filters';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalStatusCell = ({
  crmObject
}) => {
  const approvalStatus = getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.APPROVAL_PUBLISH_STATUS);
  return /*#__PURE__*/_jsx(ApprovalStatusTag, {
    approvalStatus: approvalStatus ? ApprovalValueToStatus[approvalStatus] : 'default'
  });
};
export default ApprovalStatusCell;